import { useState } from 'react';
import { Drawer, Toolbar, Box, CssBaseline } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import SidebarMenu from '../components/Comptable/dashboard/SidebarMenu';
import UserHeaderBar from '../components/Comptable/dashboard/UserHeaderBar';

const drawerWidth = 260;

const DashboardLayout = ({ children }) => {

    const {  logout } = useAuth();
    const [mobileOpen, setMobileOpen] = useState(false);

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />

            <UserHeaderBar
                onToggleSidebar={() => setMobileOpen(!mobileOpen)}
                onLogout={() => {
                    logout();
                    window.location.href = '/login';
                }}
            />

            {/* Side Drawer */}
            <Box component="nav" sx={{ width: { sm: drawerWidth }, flexShrink: 0 }}>
                <Drawer
                    variant="temporary"
                    open={mobileOpen}
                    onClose={() => setMobileOpen(false)}
                    ModalProps={{ keepMounted: true }}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': {
                            width: drawerWidth,
                            bgcolor: 'background.paper',
                            boxShadow: '1px 0 15px rgba(0, 0, 0, 0.1)',
                        },
                    }}
                >
                    <Toolbar />
                    <SidebarMenu onItemClick={() => setMobileOpen(false)} />
                </Drawer>

                <Drawer
                    variant="permanent"
                    sx={{
                        display: { xs: 'none', sm: 'block' },
                        '& .MuiDrawer-paper': {
                            width: drawerWidth,
                            bgcolor: 'background.paper',
                            boxShadow: '2px 0 12px rgba(0, 0, 0, 0.05)',
                        },
                    }}
                    open
                >
                    <Toolbar />
                    <SidebarMenu />
                </Drawer>
            </Box>

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    px: 3,
                    pt: 10,
                    pb: 5,
                    bgcolor: 'background.default',
                    minHeight: '100vh',
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                }}
            >
                {children}
            </Box>
        </Box>
    );
};

export default DashboardLayout;